'use client';

import { ContextualPopup, Divider, Flex, Typography } from '@/ui';
import { PulseChart } from '../PulseChart/PulseChart';
import styles from './PulsePopup.module.css';

export const PulsePopup = ({
  play = true,
  ids = null,
  flipped = false,
}: {
  play?: boolean;
  ids?: string[] | null;
  flipped?: boolean;
}) => (
  <ContextualPopup
    behaviour="click"
    handle={
      <div style={{ minHeight: 26 }}>
        {play && (
          <PulseChart
            highlightIds={ids}
            flipped={flipped}
            ariaLabel="My build pulse"
          />
        )}
      </div>
    }
    handleProps={{ style: { width: '100%', pointerEvents: 'auto' } }}
  >
    <ContextualPopup.Section>
      <Flex flexDirection="column" gap={4}>
        <Typography.Caption size="L">My build pulse</Typography.Caption>
        <Typography.Caption opacity={0.5} textAlign="left">
          Every code change I make gets recorded here, across companies, client
          work and other projects.
        </Typography.Caption>
      </Flex>
    </ContextualPopup.Section>

    <Divider.Horizontal />

    <ContextualPopup.Section>
      <Flex flexDirection="column" gap={8}>
        <Typography.Caption opacity={0.5} textAlign="left">
          This data proves consistency. To see that I also build the right
          things, in the right places, let&apos;s chat.
        </Typography.Caption>
        <Typography.Caption textAlign="left">
          If you&apos;re hiring, I&apos;d love to hear from you.
        </Typography.Caption>
        <Flex gap={16}>
          <Typography.Caption>
            <Typography.Link
              className={styles.bookingLink}
              href="https://calendar.app.google/p5anuDmZTMC25Erg8"
              textDecoration="rgba(255, 255, 255, 0.5) underline"
            >
              Book 30 minutes
            </Typography.Link>
          </Typography.Caption>
        </Flex>
      </Flex>
    </ContextualPopup.Section>
  </ContextualPopup>
);
